export const MORTGAGE_BANNER_HAS_BEEN_SHOWN = 'do_not_show_mortgage_banner';
export const FULL_SCREEN_BANNER_SESSION_STORAGE_KEY = 'mfab';
export const MORTGAGE_URL = `https://cian.ru/ipoteka-main/?utm_source=cian&utm_medium=trap&utm_campaign=onboarding&utm_content=mobile_web_fullscreen_percent&utm_term=main`;
